module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.a613e81.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Bold.otf
// module id = Usx2
// module chunks = 0